export default __webpack_public_path__ + "static/media/time-zone.36c0967a.svg";